import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './PcNavbar.scss';

import pulse from '../../Assets/Sounds/pulse.wav';

const PcNavbar = ({ setExplode, topPosition, darkenNavbar }) => {
  const history = useHistory();
  const location = useLocation();

  const playClick = (route) => {
    let element = document.getElementById('pulse');
    element.pause();
    element.currentTime = 0;
    element.play();
  };

  return (
    <>
      {(location.pathname == '/' ||
        location.pathname == '/about' ||
        location.pathname == '/skills' ||
        location.pathname == '/journey' ||
        location.pathname == '/projects') && (
        <div className={darkenNavbar ? `PcNavbar darken` : `PcNavbar lightem`}>
          <audio
            src={pulse}
            preload="metadata"
            type="audio/wav"
            id="pulse"
          ></audio>
          {location.pathname !== '/' && (
            <div
              onClick={() => {
                history.push('/');
                setExplode(false);
                playClick('/');
              }}
            >
              Home
            </div>
          )}
          {location.pathname !== '/about' && (
            <div
              onClick={() => {
                history.push('/about');
                setExplode(true);
                playClick('/about');
              }}
            >
              About
            </div>
          )}
          {location.pathname != '/skills' && (
            <div
              onClick={() => {
                history.push('/skills');
                setExplode(true);
                playClick('/skills');
              }}
            >
              Skills
            </div>
          )}

          {location.pathname != '/journey' && (
            <div
              onClick={() => {
                history.push('/journey');
                setExplode(true);
                playClick('/journey');
              }}
            >
              Journey
            </div>
          )}
          {location.pathname != '/projects' && (
            <div
              onClick={() => {
                history.push('/projects');
                setExplode(true);
                playClick('/projects');
              }}
            >
              Projects
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default PcNavbar;
